import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c902df1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-size-14 text-mild" }
const _hoisted_2 = { class: "upload-image-area mt-2 p-4" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "action-buttons" }
const _hoisted_5 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 button-text ml-2" }, "\n              カメラ撮影\n            ", -1))
const _hoisted_7 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 button-text ml-2" }, "\n              ファイル選択\n            ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      _createVNode(_component_AppLabel, { variant: _ctx.appLabelVariant }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.appLabelText), 1)
        ], undefined, true),
        _: 1
      }, 8, ["variant"])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppButtonOutline, { onClick: _ctx.onClickCameraButton }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FeatherIcon, {
                icon: "camera",
                size: "16"
              }),
              _createTextVNode(),
              _hoisted_6
            ])
          ], undefined, true),
          _: 1
        }, 8, ["onClick"]),
        _createTextVNode(),
        _createVNode(_component_AppButtonOutline, { onClick: _ctx.onClickSelectButton }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_FeatherIcon, {
                icon: "upload",
                size: "16"
              }),
              _createTextVNode(),
              _hoisted_8
            ])
          ], undefined, true),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}